module.exports = __webpack_public_path__ + "img/barbados.22a6f0df.png";